import { useQueryClient } from "@tanstack/react-query";
import { useApiMutation, useApiQuery } from "@/lib/query";
import type { Credential, CredentialCreate } from "./types";

/** All of the run credentials. Pickers list every one; none is tied to a platform. */
export const useCredentials = (enabled = true) => useApiQuery<Credential[]>("/credentials", {}, { enabled });

export function useCreateCredential() {
  const queryClient = useQueryClient();
  return useApiMutation<Credential, CredentialCreate>("post", "/credentials", {
    invalidate: ["/credentials"],
    // In the list at once, so a picker can select it before the refetch lands.
    onSuccess: (created) => {
      queryClient.setQueryData<Credential[]>(["/credentials", {}], (list) =>
        list ? [...list.filter((c) => c.id !== created.id), created] : list,
      );
    },
  });
}

export const useDeleteCredential = () =>
  useApiMutation<void, string>("delete", (id) => `/credentials/${id}`, { invalidate: ["/credentials"] });
